import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Dropdown, Layout, Tooltip, Typography } from "antd";
import { DownOutlined, LogoutOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons";
import actions from "../../redux/admin/actions";
import withRouter from "../../hoc/withRouter";
import { LANGUAGES, normalizeLanguage, storeLanguage } from "../../../i18n";
import { THEME_MODES } from "../../../theme";
import BrandLogo from "../../../components/BrandLogo";
import Wrapper from "./index.style";

const { Header } = Layout;
const { Text } = Typography;
const { signOut } = actions;

export class Topbar extends Component {
  handleBrandClick = () => {
    this.props.router.navigate("/admin");
  };

  handleLanguageChange = (language) => () => {
    const { i18n } = this.props;
    const next = normalizeLanguage(language);

    if (next === normalizeLanguage(i18n.language)) return;

    storeLanguage(next);
    i18n.changeLanguage(next);

    if (typeof document !== "undefined") {
      document.documentElement.lang = next;
    }
  };

  handleThemeToggle = () => {
    const { themeMode, onThemeChange } = this.props;

    onThemeChange(themeMode === THEME_MODES.dark ? THEME_MODES.light : THEME_MODES.dark);
  };

  renderLocaleSwitch() {
    const { t, i18n } = this.props;
    const language = normalizeLanguage(i18n.language);

    return (
      <div className="admin-locale-switch" aria-label={t("topbar.language.ariaLabel")}>
        <button
          className={language === LANGUAGES.el ? "on" : ""}
          onClick={this.handleLanguageChange(LANGUAGES.el)}
          type="button"
        >
          {t("topbar.language.greek")}
        </button>
        <button
          className={language === LANGUAGES.en ? "on" : ""}
          onClick={this.handleLanguageChange(LANGUAGES.en)}
          type="button"
        >
          {t("topbar.language.english")}
        </button>
      </div>
    );
  }

  renderAccountMenu() {
    const { t, operator, signOut } = this.props;

    if (!operator) {
      return <Text type="secondary">{t("admin.layout.publicState")}</Text>;
    }

    const menuItems = [
      { key: "signOut", icon: <LogoutOutlined />, label: t("admin.nav.signOut") },
    ];

    return (
      <Dropdown
        menu={{
          items: menuItems,
          onClick: ({ key }) => {
            if (key === "signOut") signOut();
          },
        }}
        placement="bottomRight"
        trigger={["hover"]}
      >
        <button className="account-menu-trigger" type="button">
          <Text className="account-menu-label">
            {operator.display_name || operator.email}
          </Text>
          <DownOutlined className="account-menu-caret" />
        </button>
      </Dropdown>
    );
  }

  render() {
    const { t, themeMode } = this.props;
    const isDark = themeMode === THEME_MODES.dark;

    return (
      <Wrapper>
        <Header className="admin-top-menu">
          <div className="admin-top-nav-header">
            <div className="admin-top-nav-header-main">
              <div className="admin-top-nav-header-main-left">
                <button
                  className="admin-top-nav-header-logo"
                  onClick={this.handleBrandClick}
                  type="button"
                >
                  <BrandLogo themeMode={this.props.themeMode} alt={t("admin.common.brand")} />
                </button>
              </div>

              <div className="admin-top-nav-header-menu" />

              <div className="admin-top-nav-header-main-right">
                <div className="admin-top-nav-header-main-right-container">
                  {this.renderLocaleSwitch()}
                  <Tooltip title={isDark ? t("topbar.theme.light") : t("topbar.theme.dark")}>
                    <button
                      className="account-menu-trigger"
                      aria-label={t("topbar.theme.ariaLabel")}
                      onClick={this.handleThemeToggle}
                      type="button"
                    >
                      {isDark ? <SunOutlined /> : <MoonOutlined />}
                    </button>
                  </Tooltip>
                  {this.renderAccountMenu()}
                </div>
              </div>
            </div>
          </div>
        </Header>
      </Wrapper>
    );
  }
}

Topbar.propTypes = {
  operator: PropTypes.shape({
    email: PropTypes.string.isRequired,
    display_name: PropTypes.string,
  }),
  themeMode: PropTypes.oneOf(Object.values(THEME_MODES)).isRequired,
  onThemeChange: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string.isRequired,
    changeLanguage: PropTypes.func.isRequired,
  }).isRequired,
  router: PropTypes.shape({ navigate: PropTypes.func.isRequired }).isRequired,
};

Topbar.defaultProps = {
  operator: null,
};

const mapStateToProps = ({ Admin }) => ({
  operator: Admin.operator,
});

const mapDispatchToProps = (dispatch) => ({
  signOut: () => dispatch(signOut()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("common")(withRouter(Topbar)));
